import { createStore } from 'zustand'

import {
  AttachmentCardOptions,
  AttachmentCardStore,
  AttachmentCardSyncState
} from './interface'

export const initialAttachmentCardState: AttachmentCardSyncState = {
  ossId: undefined,
  filename: undefined,
  mimeType: undefined,
  error: undefined,
  loading: false
}

export const createAttachmentCardStore = ({ cardRef }: AttachmentCardOptions) =>
  createStore<AttachmentCardStore>((set, get) => ({
    ...initialAttachmentCardState,
    cardRef,
    nodeKey: '',
    ossUrl: undefined
  }))
